export default function buildMakeHydrantFlush({ validate, validators, makeFlowDevice, makeHydrant }) {
  return function makeHydrantFlush({
    id,
    companyId,
    hydrantId,
    startDate,
    endDate,
    startClarity,
    duringClarity,
    endClarity,
    gallonsUsed,
    maxPsi,
    maxGpm,
    flowDeviceId,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
    flowDevice,
    hydrant,
  }) {
    try {
      const schema = {
        id: {
          prettyName: 'ID',
          validators: [validators.isString(), validators.exactLength(36)],
        },
        hydrantId: {
          prettyName: 'Hydrant ID',
          validators: [validators.notNull(), validators.isString(), validators.exactLength(36)],
        },
        startDate: {
          prettyName: 'Start Date',
          validators: [validators.notNull(), validators.isDate()],
        },
        endDate: {
          prettyName: 'End Date',
          validators: [validators.notNull(), validators.isDate()],
        },
        gallonsUsed: {
          prettyName: 'Gallons Used',
          validators: [validators.isNumber(), validators.greaterThanOrEqualTo(0)],
        },
        startClarity: {
          prettyName: 'Start Clarity',
          validators: [validators.isString()],
        },
        duringClarity: {
          prettyName: 'During Clarity',
          validators: [validators.isString()],
        },
        endClarity: {
          prettyName: 'End Clarity',
          validators: [validators.isString()],
        },
        flowDeviceId: {
          prettyName: 'Flow Device ID',
          validators: [validators.isString(), validators.exactLength(36)],
        },
      };

      return Object.freeze({
        get id() { return id },
        get companyId() { return companyId },
        get hydrantId() { return hydrantId },
        get startDate() { return startDate ? new Date(startDate) : null },
        get endDate() { return endDate ? new Date(endDate) : null },
        get startClarity() { return startClarity },
        get duringClarity() { return duringClarity },
        get endClarity() { return endClarity },
        get gallonsUsed() { return gallonsUsed },
        get maxPsi() { return maxPsi },
        get maxGpm() { return maxGpm },
        get flowDeviceId() { return flowDeviceId },
        get createdBy() { return createdBy },
        get createdDate() { return createdDate ? new Date(createdDate) : null },
        get modifiedBy() { return modifiedBy },
        get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
        get deletedBy() { return deletedBy },
        get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
        get flowDevice() { return flowDevice ? makeFlowDevice(flowDevice) : null },
        get hydrant() { return hydrant ? makeHydrant(hydrant) : null },
        validate() {
          const errors = validate(this, schema);
          if (errors.length > 0) {
            const message = errors.map(e => e.name + ': ' + e.message).join('\n');
            const validationError = new Error(message);
            validationError.name = 'ValidationError';
            throw validationError;
          }
        }
      });
    } catch (ex) {
      console.log('Error making Hydrant Flush', ex);
      throw ex;
    }
  }
}